'use strict';

var consts = require('./consts.js');

// Функция создает уникальный слушатель события POST message.
// При отправке нужного post message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginSuccess
const subscribeOnLoginSuccess = (callback) => {
    if (typeof window === "undefined") {
        return () => { };
    }
    const uniqSymbol = Symbol("Uniq key for post message handler work");
    window.sravni = {
        ...window.sravni,
        authentication: {
            // eslint-disable-next-line no-undef
            ...(window.sravni?.authentication ?? {}),
            loginSuccessPostMessageSymbol: uniqSymbol,
        },
    };
    const handler = (event) => {
        const canExecuteCallback = window.sravni.authentication.loginSuccessPostMessageSymbol ===
            uniqSymbol;
        if (!canExecuteCallback) {
            return false;
        }
        const message = event.data;
        const sourceWindow = event.source;
        if (typeof message.authMessageType !== "undefined" &&
            message.authMessageType === consts.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME &&
            typeof message !== "undefined" &&
            message.payload === true) {
            if (sourceWindow && sourceWindow.constructor.name === "Window")
                sourceWindow.close();
            callback();
        }
    };
    window.addEventListener("message", handler, false);
    return () => {
        window.sravni.authentication.loginSuccessPostMessageSymbol =
            undefined;
        window.removeEventListener("message", handler, false);
    };
};
// Функция создает уникальный слушатель события POST message.
// При отправке нужного post message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginFailure
const subscribeOnLoginFailure = (callback) => {
    if (typeof window === "undefined") {
        return () => { };
    }
    const uniqSymbol = Symbol("Uniq key for post message handler work");
    window.sravni = {
        ...window.sravni,
        authentication: {
            // eslint-disable-next-line no-undef
            ...(window.sravni?.authentication ?? {}),
            loginFailurePostMessageSymbol: uniqSymbol,
        },
    };
    const handler = (event) => {
        const canExecuteCallback = window.sravni.authentication.loginFailurePostMessageSymbol ===
            uniqSymbol;
        if (!canExecuteCallback) {
            return false;
        }
        const message = event.data;
        if (typeof message.authMessageType !== "undefined" &&
            message.authMessageType === consts.AUTH_FAILURE_LOGIN_MESSAGE_NAME &&
            typeof message !== "undefined" &&
            message.payload === true) {
            callback();
        }
    };
    window.addEventListener("message", handler, false);
    return () => {
        window.sravni.authentication.loginFailurePostMessageSymbol =
            undefined;
        window.removeEventListener("message", handler, false);
    };
};

exports.subscribeOnLoginFailure = subscribeOnLoginFailure;
exports.subscribeOnLoginSuccess = subscribeOnLoginSuccess;
//# sourceMappingURL=subscriptions.js.map
